import React, { useState } from 'react';

import {
  createCurrentUserQueryGuard,
  currentUserQueryKey,
  ensureCurrentUserData
} from '@futrli/views/queries/currentUser';
import { CurrentUserCheck, Logger } from '@futrli/shared-services';
import { queryClient } from '@futrli/views/core/queryClient';

import { initLoggedInAnalyticsTracker } from '../core/setup';
import { getCurrentUser } from '../utils/user';

/**
 * Setup analytics tracker
 */
export const useAnalyticsTrackerInit = () => {
  const [areAnalyticsInitialised, setAreAnalyticsInitialised] = useState<boolean>(false);

  React.useEffect(() => {
    if (areAnalyticsInitialised) {
      return;
    }

    let active = true;
    // Create the query before the SDK lookup so logout can invalidate work before profile loading starts.
    queryClient.getQueryCache().build<unknown>(queryClient, { queryKey: currentUserQueryKey() });
    const isSameSession = createCurrentUserQueryGuard();
    const isCurrent = () => active && isSameSession();

    const initialiseAnalytics = async () => {
      const user = await getCurrentUser();
      let currentUser: CurrentUserCheck | null = null;
      try {
        currentUser = await ensureCurrentUserData();
      } catch (e) {
        Logger.error('Error during fetching current user');
      }
      if (isCurrent()) {
        await initLoggedInAnalyticsTracker(user, currentUser?.i_hash, isCurrent);
        if (isCurrent()) {
          setAreAnalyticsInitialised(true);
        }
      }
    };
    initialiseAnalytics().catch(error => Logger.error(String(error)));
    return () => {
      active = false;
    };
  }, [areAnalyticsInitialised]);
};
